import * as React from 'react'

import type { DefaultProps } from '@/types/common'

import S from './Y_DivideTemplate.style'

type Props = DefaultProps

const Y_DivideTemplate = ({ children, className, style, ...props }: Props) => {
  return (
    <div className={className} style={style} css={S.basic} {...props}>
      {children}
    </div>
  )
}

export default Y_DivideTemplate
